import { render, staticRenderFns } from "./szxcell.vue?vue&type=template&id=724f3179&scoped=true"
import script from "./szxcell.vue?vue&type=script&lang=js"
export * from "./szxcell.vue?vue&type=script&lang=js"
import style0 from "./szxcell.vue?vue&type=style&index=0&id=724f3179&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724f3179",
  null
  
)

export default component.exports